// extracted by mini-css-extract-plugin
export var book = "laundryLove-module--book--ebda0";
export var container = "laundryLove-module--container--e0691";
export var headerContainer = "laundryLove-module--headerContainer--16a32";
export var image = "laundryLove-module--image--0c99c";
export var imageContainer = "laundryLove-module--imageContainer--fbdf5";
export var main = "laundryLove-module--main--ae286";
export var text = "laundryLove-module--text--941f8";
export var title = "laundryLove-module--title--5e745";